import React from 'react';
import {
  Button
} from 'reactstrap';
import Rosters from '../API/Rosters';

interface AuthProps {
  isAuthenticated: boolean;
  authButtonMethod: any;
  user: any;
}


// Handle Sign-In Button
function WelcomeContent(props: AuthProps) {
  if (props.isAuthenticated) {
    // Authenticated
    return <Button className="btn-primary" href="#" role="button" onClick={props.authButtonMethod}>Sign Out</Button>;
  } else {
    // Not authenticated
    return <Button className="btn-primary" color="primary" href="#" role="button" onClick={props.authButtonMethod}>Sign In</Button>;
  }
}

export default class AuthButton extends React.Component<AuthProps> {
  render() {
    return (
      <div>
        
        <WelcomeContent
          isAuthenticated={this.props.isAuthenticated}
          user={this.props.user}
          authButtonMethod={this.props.authButtonMethod} />

        <section className="content-area white">
          <div className="card-md">
            <Rosters />
          </div>
        </section>

      </div>
    );

  }
}